import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 22,
	viewBox: "0 0 23 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.6236 2.2H18.3972V1.1C18.3972 0.495 17.8452 0 17.1707 0C16.4961 0 15.9442 0.495 15.9442 1.1V2.2H6.13239V1.1C6.13239 0.495 5.58047 0 4.90591 0C4.23135 0 3.67943 0.495 3.67943 1.1V2.2H2.45295C1.09156 2.2 0.0122648 3.19 0.0122648 4.4L0 19.8C0 21.01 1.09156 22 2.45295 22H19.6236C20.9728 22 22.0766 21.01 22.0766 19.8V4.4C22.0766 3.19 20.9728 2.2 19.6236 2.2ZM19.6233 18.7C19.6233 19.305 19.0714 19.8 18.3968 19.8H3.6791C3.00453 19.8 2.45262 19.305 2.45262 18.7V7.7H19.6233V18.7ZM4.90524 9.9H7.35819V12.1H4.90524V9.9ZM9.81266 9.9H12.2656V12.1H9.81266V9.9ZM14.7176 9.9H17.1706V12.1H14.7176V9.9Z",
		fill: "#395566"
	})
});
export default SvgFill;
